import type { LocationHighlightRow } from "@contracts/socialReports";
import type { LocationData } from "@contracts/socialLocations";
import { categoryOptionFor, LOCATION_CATEGORY_OPTIONS, type LocationCategoryOption } from "./LocationCategories.ts";

export interface LocationCategoryCoverage {
  option: LocationCategoryOption;
  highlightedCount: number;
  totalCount: number;
}

// Other is kept last in the shared category options.
const OTHER_CATEGORY = LOCATION_CATEGORY_OPTIONS[LOCATION_CATEGORY_OPTIONS.length - 1];

/** Uses the report's filtered post counts; a location is highlighted once, regardless of how many posts feature it. */
export function buildLocationCoverageByCategory(rows: readonly LocationHighlightRow[], locationsById: Readonly<Record<string, LocationData>>): LocationCategoryCoverage[] {
  const groups = new Map<string, LocationCategoryCoverage>();
  for (const row of rows) {
    if (row.isArchived || row.tagKind === "Person") continue;
    const option = categoryOptionFor(row.tagKind, locationsById[row.locationId]?.category) ?? OTHER_CATEGORY;
    let group = groups.get(option.value);
    if (!group) {
      group = { option, highlightedCount: 0, totalCount: 0 };
      groups.set(option.value, group);
    }
    group.totalCount++;
    if (row.postCount > 0) group.highlightedCount++;
  }

  return [...groups.values()].sort((a, b) => b.highlightedCount - a.highlightedCount || a.option.label.localeCompare(b.option.label));
}
